import React from "react";
import classNames from "classnames";
import { AppSegmented } from "@/shared/Components";
import styles from "./styles.module.scss";

interface Props {
  controls: { value: string; label: string }[];
  onChange: (value: string | number) => void;
  className?: string;
  defaultValue?: string | number;
}

export const WidgetControls: React.FC<Props> = ({ controls, onChange, defaultValue }) => {
  return (
    <div className={classNames(styles.root)}>
      <AppSegmented defaultValue={defaultValue} options={controls} onChange={onChange} />
    </div>
  );
};
